import React, { useContext } from 'react';
import styles from './header.module.css';
import classNames from "classnames";

const url = new URL(window.location.href);
const name = url.searchParams.get('name');

export function Header() {

  return (
    <div className={`${styles.container} row`}>
        <div id={'element_name'} className={styles.heading}>
        Конструктор
      </div>
    </div>
  );
}
